<script setup lang="ts">
import EditMenuDrawer from '@/pages/erp/ds/menu/view/ds-menu-drawer.vue'
import type { MenuProperties } from '@/pages/erp/ds/menu/db/ds-menu-types'
import Swal from 'sweetalert2'
import DsSysDialog from "@/pages/erp/ds/menu/view/ds-sys-dialog.vue";
import ExportDialog from "@/pages/erp/du/user/view/du-management-export-dialog.vue";
definePage({
    meta: {
        action: 'manage',
        subject: 'DSMENU',
    },
})

const compId = ref(useStorage('compNo', 'nstc').value)
const menuId = ref()
const menuType = ref('S')
const menuDesc = ref()
const groupDesc = ref('NSTC')

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '#', key: 'id', width: 20 },
    { title: '系統代號', key: 'menuId', width: 150 },
    { title: '系統名稱', key: 'menuDesc', width: 300  },
    { title: '系統連結', key: 'path' },
    // { title: '授權', key: 'authorityGroup' },
    { title: '操作', key: 'actions', sortable: false, width: 250}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: menusData, execute: fetchMenus } = await useApi<any>(createUrl('/ds/menu/menu/searchMenu', {
  query: {
    compId,
    menuId,
    menuType,
    menuDesc,
    groupDesc,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): MenuProperties[] => menusData.value.data.menuPage.content)
const totalDatas = computed(() => menusData.value.data.menuPage.totalElements)

console.log('datas: ', datas)

const isEditDataDialogVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

const voData = ref<MenuProperties>({} as MenuProperties)


const createData = () => {
  isEditDataDialogVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (menuData: MenuProperties) => {
  voData.value = menuData
  console.log('editMenu: ', voData)
  isEditDataDialogVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (menuData: MenuProperties) => {
    voData.value = menuData
    console.log('copyMenu: ', voData)
  isEditDataDialogVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (menuData: MenuProperties) => {
  const groupData = {
    compId: menuData.compId,
    groupId: menuData.authorityGroup,
    owner: menuData.owner,
    groupDesc: menuData.menuDesc,
    groupType: 'G'
  }
  await $api('/ds/auth/group/createGroup', {
    method: 'POST',
    body: { group: groupData },
  })

  await $api('/ds/menu/menu/createMenu', {
    method: 'POST',
    body: { menu: menuData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchMenus()
}

const updateData = async (menuData: MenuProperties) => {
  await $api('/ds/menu/menu/updateMenu', {
    method: 'PUT',
    body: { menu: menuData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchMenus()
}

  // 👉 Delete data
const deleteData = async (menuData: MenuProperties) => {
  const { menuId } = menuData
    $swal({
    title: `確定要刪除 ${menuData.menuId} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/ds/menu/menu/deleteMenu`, {
        method: 'DELETE',
        query: {
          menuId
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchMenus()
      })
    }
  });

}

const clickRow = (event: any, select: { item: MenuProperties; }) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

const isExportDialogVisible = ref(false)

const exportBtn =  () => {
  isExportDialogVisible.value=true
  // exportUsers()
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
          cols="12"
          sm="4"
        >
          <AppInput
            v-model="menuDesc"
            type="text"
            clearable
            placeholder="系統名稱"
            :disabled="false"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />
    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />
      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
<!--        <VBtn-->
<!--          class="ml-4"-->
<!--          color="primary"-->
<!--          variant="tonal"-->
<!--          prepend-icon="tabler-download"-->
<!--          @click="exportBtn"-->
<!--        >-->
<!--          匯出-->
<!--        </VBtn>-->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增系統
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.id="{ item, index }">
        <div class="text-body-1 text-high-emphasis">
          {{ index + 1 }}
        </div>
      </template>

      <template #item.menuDesc="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.menuDesc }}
          </div>
      </template>

      <template #item.path="{ item }">
        <div class="text-body-1 text-high-emphasis">
          {{ item.path }}
        </div>
      </template>

<!--      <template #item.authorityGroup="{ item }">-->
<!--        <IconBtn :to="{ name: 'erp-ds-menu-view-id', params: { id: item.menuId } }">-->
<!--          <VIcon icon="tabler-lock-plus" />-->
<!--          <v-tooltip-->
<!--            activator="parent"-->
<!--            location="bottom"-->
<!--          >系統授權</v-tooltip>-->
<!--        </IconBtn>-->
<!--      </template>-->

      <!-- Actions -->
      <template #item.actions="{ item }">
        <VBtn
          class="mr-3"
          variant="outlined"
          density="compact"
          :to="{ name: 'erp-ds-menu-view-id', params: { id: item.menuId } }"
        >
          編輯
        </VBtn>

        <VBtn
          class="mr-3"
          variant="outlined"
          density="compact"
          @Click="deleteData(item)"
        >
          刪除
        </VBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <DsSysDialog
    v-if="isEditDataDialogVisible"
    v-model:isDialogVisible="isEditDataDialogVisible"
    :menu-data="voData"
    :is-new="isNewData"
    :is-copy="isCopyData"
    @create-data="addNewData"
    @update-data="updateData"
  />
  <ExportDialog
    v-model:isDialogVisible="isExportDialogVisible"
    export-api="/ds/menu/menu/exportMenu"
  />

</template>
